module.exports = __webpack_public_path__ + "fonts/GreycliffCF-Regular.71c86d6.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/GreyCliff/GreycliffCF-Regular.ttf
// module id = 297
// module chunks = 245 246